import { html } from 'lit';
import { property, query } from 'lit/decorators.js';
import { styles } from '../view/styles';
import { InputEvents } from '../../gzInput/types';
import { FormFieldInput } from '../../gzForm/formField/component/FormFieldInput';
import { TemplateResult } from 'lit/development';

export class GzInputFileWebComponent extends FormFieldInput<FileList | null> {
  @property({ type: String, attribute: true, reflect: true })
  accept = '*';

  @property({ attribute: true, reflect: true })
  value;

  @property({ attribute: true, reflect: true })
  multiple = false;

  @property({ attribute: true, reflect: true })
  showFileNames = false;

  @property({ attribute: true, reflect: true })
  fileSizeLimit: number;

  @query('input')
  protected inputElement!: HTMLInputElement;

  private cachedBrowseButton!: HTMLElement;

  public get BrowseButton(): HTMLElement {
    if (this.cachedBrowseButton === undefined) {
      const button = this.querySelector('[browse-button]');
      if (!button) {
        throw new Error('No browse button in file input');
      }

      this.cachedBrowseButton = button as HTMLElement;
    }

    return this.cachedBrowseButton;
  }

  connectedCallback() {
    super.connectedCallback();
    this.BrowseButton.addEventListener('click', () => {
      this.inputElement.click();
    });
  }

  public setFormValue(value: FileList | null) {
    this.value = value;
    this.emitInputEvent(InputEvents.CHANGE);
    if (value === null) {
      this.inputElement.value = '';
    }
  }

  public getFormValue(): FileList | null {
    return this.value;
  }

  public setEnabled(isEnabled: boolean): void {
    this.inputElement.disabled = !isEnabled;
  }

  private onUserInput() {
    this.setFormValue(this.inputElement.files);
  }

  private emitInputEvent(eventName: string) {
    const event = new CustomEvent(eventName, {
      detail: {
        sourceEvent: this.inputElement.value,
      },
      bubbles: true,
      cancelable: true,
      composed: false,
    });
    this.dispatchEvent(event);
  }

  private emptyFileList(): void {
    this.setFormValue(null);
  }

  private renderFileNames(): TemplateResult | undefined {
    if (!this.showFileNames || !this.value || this.value?.length === 0) {
      return;
    }
    const allNames = [...this.value].map(file => file.name).join(', ');
    return html`
      <div class="file-names-wrapper">
        <gz-chip text=${allNames} notSelectable removable @removeChip="${this.emptyFileList}" />
      </div>
    `;
  }

  static get styles() {
    return styles;
  }

  public render() {
    return html`
      <div class="${this.invalid ? 'invalid' : ''}">
        <input hidden ?multiple="${this.multiple}" type="file" accept="${this.accept}" @change="${this.onUserInput}" />
        <slot></slot>
        ${this.renderFileNames()}
      </div>
    `;
  }
}
